(() => {
  document.addEventListener("DOMContentLoaded", () => {

    // Script tag'indeki section.id ile benzersiz container'ı bul
    const scriptTag = document.querySelector("script[data-section-id]");
    if (!scriptTag) return;

    const sectionId = scriptTag.dataset.sectionId;
    const container = document.getElementById(`ft-video-${sectionId}`);
    if (!container) return;

    // Tüm sorgular container'a kilitli
    const videoEl = container.querySelector(".cs_ft-video");
    const playBtn = container.querySelector(".cs_video-play");
    const muteBtn = container.querySelector(".cs_video-mute");
    const { desktopVideo, mobileVideo } = container.dataset;

    let videoLoaded = false;

    function loadVideo() {
      if (videoLoaded) return;
      videoLoaded = true;

      videoEl.src = window.innerWidth > 768 ? desktopVideo : mobileVideo;
      videoEl.load();
      videoEl.play().then(syncPlayState).catch(() => {});

      videoEl.addEventListener("canplay", () => {
        container.querySelectorAll(".c-hp-video-banner-poster")
          .forEach(el => el.remove());
      }, { once: true });

      ["click", "keypress", "touchstart", "scroll"].forEach(ev =>
        document.removeEventListener(ev, loadVideo)
      );
    }

    ["click", "keypress", "touchstart", "scroll"].forEach(ev =>
      document.addEventListener(ev, loadVideo, { passive: true })
    );

    function syncPlayState() {
      const paused = videoEl.paused;
      playBtn.classList.toggle("is-paused", paused);
      playBtn.setAttribute("aria-label", paused ? "Play" : "Pause");
    }

    function syncMuteState() {
      const muted = videoEl.muted;
      muteBtn.classList.toggle("is-unmuted", !muted);
      muteBtn.setAttribute("aria-label", muted ? "Unmute" : "Mute");
    }

    playBtn.addEventListener("click", () => {
      if (!videoLoaded) { loadVideo(); return; }
      videoEl.paused ? videoEl.play() : videoEl.pause();
      syncPlayState();
    });

    muteBtn.addEventListener("click", () => {
      videoEl.muted = !videoEl.muted;
      syncMuteState();
    });

    videoEl.addEventListener("play",  syncPlayState);
    videoEl.addEventListener("pause", syncPlayState);

    syncMuteState();
    syncPlayState();
  });
})();